import { formatPrice } from "libs/utils/format";
import { get, startCase } from "lodash";
import * as yup from "yup";

export const isError = (fieldName, formik) =>
  get(formik.touched, fieldName, "") &&
  Boolean(get(formik.errors, fieldName, ""));

export const getErrorMessage = (fieldName, formik) =>
  get(formik.touched, fieldName, "")
    ? get(formik.errors, fieldName, "") || " "
    : " ";

export function sortByName(fileName) {
  return (a, b) => {
    const nameA = a[fileName]?.toUpperCase(); // ignore upper and lowercase
    const nameB = b[fileName]?.toUpperCase(); // ignore upper and lowercase

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  };
}

export const mapFieldValidate = (p, c) => {
  if (["int", "double"].includes(c.conditionValue)) {
    const minValue = get(c, "conditionValueMax", "0");
    return {
      ...p,
      [c.conditionField]: yup
        .number()
        .min(
          minValue,
          `${startCase(c.conditionField)} should more than ${formatPrice(
            minValue
          )}`
        )
        .required(),
    };
  } else {
    return {
      ...p,
      [c.conditionField]: yup.string().required(),
    };
  }
};

export const mapFieldValidateWithFieldName =
  (fieldName = "conditionField") =>
  (p, c) => {
    if (["int", "double"].includes(c.conditionValue)) {
      const minValue = get(c, "conditionValueMax", "0");
      return {
        ...p,
        [c.conditionField]: yup
          .number()
          .min(
            minValue,
            `${fieldName} should more than ${formatPrice(minValue)}`
          )
          .required(`${fieldName} is a required field`),
      };
    } else {
      return {
        ...p,
        [c.conditionField]: yup.string().required(),
      };
    }
  };

export const getDefaultRow = (rawData, key, defaultvalue) => {
  const value = get(rawData, key, [defaultvalue]);
  if (value.length === 0) return [defaultvalue];
  return value;
};

export const defaultSpouse = {
  spouseId: null,
  spouseName: "",
  spouseBirthDate: "",
  spouseNationality: "",
  spouseOccupation: "",
  status: true,
};
export const mapSpouse = (value) => ({
  spouseId: value.spouseId,
  SpouseName: value.spouseName,
  SpouseBirthDate: value.spouseBirthDate,
  SpouseNationality: value.spouseNationality,
  SpouseOccupation: value.spouseOccupation,
  Status: value.status,
});
export const defaultChildren = {
  childrenId: null,
  childrenName: "",
  childrenBrithDate: "",
  childrenNationality: "",
  childrenOccuption: "",
  status: true,
};
export const mapChildren = (value) => ({
  childrenId: value.childrenId,
  ChildrenName: value.childrenName,
  ChildrenBrithDate: value.childrenBrithDate,
  ChildrenNationality: value.childrenNationality,
  ChildrenOccuption: value.childrenOccuption,
  Status: value.status,
});
export const defaultCompanies = {
  companiesId: null,
  companyName: "",
  valueofShares: null,
  amountOfConvertibledebt: null,
  sameCompany: false,
  status: true,
};
export const mapCompanies = (value) => ({
  companiesId: value.companiesId,
  CompanyName: value.companyName,
  ValueofShares: value.valueofShares,
  AmountOfConvertibledebt: value.amountOfConvertibledebt,
  SameCompany: value.sameCompany,
  Status: value.status,
});
export const defaultStakeholders = {
  stakeholdersId: null,
  name: "",
  company: "",
  position: "",
  contactDetail: "",
  status: true,
};
export const mapStakeholders = (value) => ({
  stakeholdersId: value.stakeholdersId,
  Name: value.name,
  Company: value.company,
  Position: value.position,
  ContactDetail: value.contactDetail,
  Status: value.status,
});

export const getPartFormId = (defaultType, partFromName) => {
  const partfromId =
    defaultType.find((field) => field.partFromName === partFromName)
      ?.partfromId || "";

  return partfromId;
};

export const getValueByPartForm = (
  smartform,
  fieldListByPartForm,
  partfromId
) => {
  const detail = get(smartform, "detail", [])
    .filter((field) => field.partfromId === partfromId)
    .filter((field) => fieldListByPartForm.includes(field.smartName))
    .reduce((p, c) => ({ ...p, [c.smartName]: c }), {});

  return detail;
};

export const defaultEducationData = {
  educationId: null,
  fileID: null,
  educationName: "",
  yearOfGraduation: "",
  nameOfEducation: "",
  countryId: "",
  cityID: "",
  fieldOfStudy: "",
  filename: "",
  ext: "",
  status: true,
  ocrText: "",
  isDetect: false,
};
export const mapEducationData = (value) => ({
  educationId: value.educationId,
  FileID: value.fileID,
  educationName: value.educationName,
  YearOfGraduation: value.yearOfGraduation,
  NameOfEducation: value.nameOfEducation,
  countryId: value.countryId,
  CityID: value.cityID,
  FieldOfStudy: value.fieldOfStudy,
  filename: value.filename || "",
  ext: value.ext || "",
  Status: value.status || false,
  OcrText: value.ocrText || "",
  IsDetect: value.isDetect || false,
});
export const defaultWorkExperience = {
  workId: null,
  fileID: null,
  preiodFrom: "",
  preiodTo: "",
  workOrganization: "",
  countryId: "",
  workCity: "",
  workResponsibility: "",
  status: true,
  ext: "",
  filename: "",
};
export const mapWorkExperience = (value) => ({
  workId: value.workId,
  FileID: value.fileID,
  PreiodFrom: value.preiodFrom,
  PreiodTo: value.preiodTo,
  WorkOrganization: value.workOrganization,
  countryId: value.countryId,
  WorkCity: value.workCity,
  WorkResponsibility: value.workResponsibility,
  Status: value.status,
  ext: value.ext,
  filename: value.filename,
});
export const defaultJobTable = {
  jobpositionID: null,
  jobID: "",
  jobsubID: "",
  jobTitle: "",
  jobDesc: "",
  status: true,
};
export const mapJobTable = (value) => ({
  jobpositionID: value.jobpositionID,
  jobID: value.jobID,
  jobsubID: value.jobsubID,
  jobTitle: value.jobTitle,
  jobDesc: value.jobDesc,
  Status: value.status,
});
export const defaultShareholder = {
  shareholderId: null,
  nameOfCompany: "",
  sharesPercent: "",
  nationalityID: "",
  status: true,
};
export const mapShareholder = (value) => ({
  shareholderId: value.shareholderId,
  NameOfCompany: value.nameOfCompany,
  SharesPercent: value.sharesPercent,
  NationalityID: value.nationalityID,
  Status: value.status,
});

export const defaultShareholders = {
  shareholderID: null,
  shareholderPercent: 0,
  nationalityID: null,
  status: true,
};
export const mapShareholders = (value) => ({
  shareholderID: value.shareholderID,
  shareholderPercent: value.shareholderPercent,
  nationalityID: value.nationalityID,
  status: defaultShareholders.status,
});
